<template>
    <div>
        <label class="form-label">Produtos</label>
        <Multiselect
            v-model="selectedProductIds"
            :options="getOptions"
            mode="tags"
            searchable
            :multipleLabel="getMultipleLabel"
            noOptionsText="Nenhuma opção disponível"
            noResultsText="Nenhum resultado encontrado"
            canClear
            :hideSelected="false"
            :native="false"
            ref="multiselect"
            :loading="loading"
        >
            <template v-slot:option="{ option, isSelected }">
                <b-form-checkbox
                    value="checked"
                    :checked="isSelected(option) ? 'checked' : 'unchecked'"
                />

                {{ option.label }}
            </template>
        </Multiselect>

        <a
            class="toggleAllButton"
            v-if="!allProductsAreSelected"
            @click="selectAllProducts"
        >
            Selecionar todos
        </a>
        <a class="toggleAllButton" v-else @click="deselectAllProducts">
            Desselecionar todos
        </a>
    </div>
</template>

<script>
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";

export default {
    props: {
        products: Array,
        chosenProducts: Array,
        loading: Boolean,
    },
    components: {
        Multiselect,
    },
    data: () => ({
        selectedProductIds: [],
    }),
    computed: {
        getOptions() {
            return this.products.map((product) => ({
                value: product.id,
                label: product.name,
            }));
        },
        allProductsAreSelected() {
            return this.products.length === this.selectedProductIds.length;
        },
    },
    methods: {
        getSelectedProducts(productIds) {
            return this.products.filter((product) =>
                productIds.includes(product.id)
            );
        },
        getMultipleLabel(value) {
            return `${value.length} produtos selecionados`;
        },
        handleChange(value) {
            this.$emit("onSelectedProducts", this.getSelectedProducts(value));
        },
        selectAllProducts() {
            this.$refs.multiselect.selectAll();
        },
        deselectAllProducts() {
            this.$refs.multiselect.clear();
        },
        setupSelected() {
            if (this.products.length <= 10) {
                this.selectedProductIds = this.products.map(
                    (product) => product.id
                );
            }
        },
    },
    watch: {
        products: {
            handler() {
                this.setupSelected();
            },
            immediate: true,
        },
        selectedProductIds: {
            handler(value) {
                this.handleChange(value);
            },
        },
    },
};
</script>

<style src="@vueform/multiselect/themes/default.css" />

<style lang="scss">
:root {
    --ms-tag-bg: #131552;
    --ms-tag-color: #fff;
    --ms-tag-font-weight: 400;
    --ms-option-bg-selected: transparent;
    --ms-option-color-selected: #000;
    --ms-option-bg-pointed: #ccc;
    --ms-option-color-pointed: #000;
    --ms-option-bg-selected-pointed: #ccc;
    --ms-option-color-selected-pointed: #000;
    --ms-border-color-active: #2b30ba;
    --ms-ring-color: rgba(19, 21, 82, 0.25);
    --ms-line-height: 1.175;
}
</style>

<style scoped lang="scss">
.toggleAllButton {
    display: inline-block;
    cursor: pointer;
    margin-top: 5px;
    margin-bottom: 10px;
}
.select-option-checkbox {
    margin-right: 5px;
}
</style>
